export const loadGTM = (gtmId) => {
  if (!gtmId) return;

  // If same GTM already loaded → do nothing
  if (window.gtmLoadedId === gtmId) return;

  window.gtmLoadedId = gtmId;

  // Remove any previous GTM before loading new
  document.querySelectorAll("script[data-gtm], noscript[data-gtm]").forEach(el => el.remove());

  // Add script
  const script = document.createElement("script");
  script.setAttribute("data-gtm", gtmId);
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
  document.head.appendChild(script);

  // Add noscript
  const noscript = document.createElement("noscript");
  noscript.setAttribute("data-gtm", gtmId);
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.body.prepend(noscript);
};

// Completely remove GTM
export const removeGTM = () => {
  window.gtmLoadedId = null;
  document.querySelectorAll("script[data-gtm], noscript[data-gtm]").forEach(el => el.remove());
};